import { useDrag } from "client/hooks/utils/useDrag";
import type { ReactNode, RefObject } from "react";
import { MemeGeneratorState, MemeIconState } from "store/features/memeGenerator/types";

interface IconContainerProps {
    children: ReactNode;
    icon: NonNullable<MemeGeneratorState["meme"]>["icons"][number];
    isDownloading: boolean;
    iconContainerClick?: () => void;
    iconContainerRef?: RefObject<HTMLDivElement>;
    dragHandlers?: ReturnType<typeof useDrag>["dragHandlers"];
}

export const IconContainer = ({
    children,
    icon,
    isDownloading,
    iconContainerClick,
    iconContainerRef,
    dragHandlers,
}: IconContainerProps) => {
    return (
        <div
            className="absolute cursor-move touch-none"
            style={{
                position: "absolute",
                left: 0,
                top: 0,
                width: icon.settings.width,
                height: icon.settings.height,
                transform: `translate(${icon.settings.left}px,${icon.settings.top}px) rotate(${icon.settings.rotation}deg)`,
                zIndex: 10 + icon.zIndex,
            }}
            ref={iconContainerRef}
            onClick={iconContainerClick}
            {...dragHandlers}
        >
            <div
                className={`w-full h-full relative ${
                    !isDownloading && (icon.showBorder || icon.state === MemeIconState.ACTIVE)
                        ? "mg-textBox-border"
                        : ""
                }`}
            >
                <img
                    src={icon.icon.src}
                    draggable={false}
                    className="absolute left-0 top-0"
                    style={{
                        width: icon.settings.width,
                        height: icon.settings.height,
                    }}
                />
                {children}
            </div>
        </div>
    );
};
